<template>
  <span class="co2StateWidget">
    <template v-if="!facility_co2Enabled">
      <span title="CO2 disabled in the facility">
        <v-icon v-if="!disabled" :size="iconSize" color="silver">cloud_off</v-icon>
        <v-icon v-else :size="iconSize" color="rgb(192, 192, 192)">cloud_off</v-icon>
      </span>
    </template>
    <template v-else>
      <template v-if="!co2Enabled">
        <span title="CO2 disabled in ECU: Valve closed">
          <v-icon v-if="!disabled" :size="iconSize">cloud_off</v-icon>
          <v-icon v-else color="rgb(192, 192, 192)" :size="iconSize">cloud_off</v-icon>
        </span>
      </template>
      <template v-else>
        <template v-if="value == 'ON'">
          <span title="CO2 enabled in ECU: Valve opened">
            <v-icon v-if="!disabled" :size="iconSize" color="green">cloud_queue</v-icon>
            <v-icon v-else :size="iconSize" color="rgb(192, 192, 192)">cloud_queue</v-icon>
          </span>
        </template>
        <template v-else>
          <span title="CO2 enabled in ECU: Valve closed">
            <v-icon v-if="!disabled" :size="iconSize">cloud_queue</v-icon>
            <v-icon v-else color="rgb(192, 192, 192)" :size="iconSize">cloud_queue</v-icon>
          </span>
        </template>
      </template>
    </template>
  </span>
</template>

<script>
export default {
  name: "co2-state",
  props: ["value", "iconSize", "co2Enabled", "facility_co2Enabled", "debug", "disabled"],

  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
